<template>
  <vs-card class="w-full collapse-cstm-card">

    <!-- Yasin Quraishy
    <pre> {{ platform_customer_id }}asss</pre> -->

     <div class="">
      <span style="color: green;">&#10004; = Marked &nbsp; </span>
      <span style="color: red;">&#10008; = Unmarked </span>
     </div>

     <vs-divider/>

    <div v-if="lessonAssignment.length">
      <vs-collapse 
    v-for="(eachAssignment,index) in lessonAssignment" :key="index"
    >
      <vs-collapse-item>
        <div slot="header">
          <span>{{eachAssignment.assignment.title}}</span>

           <div class="marked_unmarked_indicator">
              <div class="indicator" v-if="eachAssignment.sub_total_marks_given > 0">
                <vs-tooltip text="Marked">
                  <span>&#10004;</span>
                </vs-tooltip>
              </div>
              <div v-else>
                <vs-tooltip text="Unmarked">
                  <span>&#10008;</span>
                </vs-tooltip>
              </div>
           </div>
          
          <div class="each_set_total_marks" v-if="assignmentType !== 'report'">
            <span>
              Total <span class="marks">{{eachAssignment.sub_total_marks}}</span>
            </span>
          </div>
        </div>
        <!-- <pre>{{eachAssignment.assignment.questions}}</pre> -->
        <question-modal
          :QuestionModal="eachAssignment.assignment.questions"
           Modaltype="assignment"
          :assignment_type_id="eachAssignment.assignment.assignment_type_id"
          :lessonId="eachAssignment.lesson_id"
          :course_id="eachAssignment.course_id"
          :sectionType="sectionType"
          :platform_customer_id="platform_customer_id"
        ></question-modal>

        
      </vs-collapse-item>
    </vs-collapse>
    </div>
    <div v-else>
       <h5 class="text-center" style="padding:10px;color:#626262">No content found</h5>
    </div>
    
  </vs-card>
</template>
<script>
import QuestionModal from './QuestionModal.vue'

export default {
  name: 'AssignmentModal',
  components: {
    QuestionModal
  },
  props: {
    assignmentType: {},
    lessonAssignment: {
      type: Array,
      required: true,
      default: () => []
    },
    sectionType:{
      type:Number,
      default:null
    },
    platform_customer_id:{}
  },
  created () {
    //console.log('On Created lessonAssignment', this.lessonAssignment)
    const homework_subtotal = this.lessonAssignment.map((x) => {
      x.sub_total_marks = 0
      x.sub_total_marks_given = 0
      return x.assignment.questions
        .map((y) => {
          if (y.student_answers_new.student_answer_id !== null) {
            if (y.student_answers_new.mark !== undefined) {
              x.sub_total_marks_given += Number(y.student_answers_new.mark)
            }
          }
          x.sub_total_marks += y.point
          //console.log(y)
        })
        .filter(Boolean)
    })

    console.log(homework_subtotal)

    // setTimeout(() => {
    //   homework_subtotal = [].concat.apply([], homework_subtotal)
    //   exam_subtotal = [].concat.apply([], exam_subtotal)

    //   this.homework_statistic = homework_subtotal.reduce((a, b) => a + b, 0)
    //   this.exam_statistic = exam_subtotal.reduce((a, b) => a + b, 0)
    //   this.total_statistic = this.homework_statistic + this.exam_statistic
    // }, 100)
    
  }
}
</script>

<style scoped>
.marked_unmarked_indicator{
    text-align: center;
    width: 30px;
    font-size: 13px;
    float: left;
    padding: 5px 10px;
    margin-right: 50px;
    background-color: rgba(var(--vs-primary), 1);
    border-radius: 5px;
    color: white;
}

.each_set_total_marks{
    font-size: 15px;
    float: right;
    padding: 5px 10px;
    margin-right: 50px;
    background-color: rgba(var(--vs-primary), 1);
    border-radius: 5px;
    color: white;
    box-shadow: 0px 0px 15px #00000026;
}

.each_set_total_marks .marks {
    background: rebeccapurple;
    padding: 3px 5px;
    border-radius: 5px;
    font-size: 12px;
    box-shadow: 0px 0px 1px black;
}
</style>